<figure class="cs-annimg" [class.cs-annimg--zoom]="zoomed">
	<div class="cs-annimg__frame" (click)="toggleZoom()" [title]="zoomed ? 'Click to shrink' : 'Click to enlarge'"
	     style="position:relative; display:inline-block; max-width:100%; line-height:0; cursor:zoom-in;">
		<img class="cs-annimg__img" [src]="resolvedSrc" [alt]="spec.alt || ''" draggable="false"
		     style="display:block; width:100%; height:auto; border-radius:8px;" />
		@for (b of boxes; track trackBox($index, b)) {
			<div class="cs-annimg__box" [ngStyle]="b.box" [title]="b.tooltip">
				@if (b.label) {
					<span class="cs-annimg__label" [ngStyle]="b.label">{{ b.labelText }}</span>
				}
			</div>
		}
	</div>
	@if (spec.alt) {
		<figcaption class="cs-annimg__cap">{{ spec.alt }}</figcaption>
	}
</figure>
